import { createIcon } from '@chakra-ui/icon';

export const ChevronUpIcon = createIcon({
  displayName: 'ChevronUpIcon',
  viewBox: '0 0 136 136',
  defaultProps: {
    width: '100%',
    height: '100%',
  },
  path: (
    <>
      <defs>
        <filter id="dropshadow" height="130%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="8" />
          <feOffset dx="2" dy="2" result="offsetblur" />
          <feComponentTransfer>
            <feFuncA type="linear" slope="0.5" />
          </feComponentTransfer>
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g transform="translate(-620.000000, -3934.000000)">
        <g transform="translate(639.000000, 3953.000000)">
          <g>
            <g>
              <circle className="circle" fill="#fff" cx="49" cy="49" r="50.5" />
              <path
                className="border"
                fill={'currentColor'}
                d="M49,101C20.3,101-3,77.7-3,49S20.3-3,49-3s52,23.3,52,52S77.7,101,49,101z M49,0C22,0,0,22,0,49
                s22,49,49,49s49-22,49-49S76,0,49,0z"
              />
            </g>
          </g>
          <g transform="translate(21.984143, 26.000000)">
            <g>
              <path
                className="caret"
                fill={'currentColor'}
                d="M2.1,32.8L23.8,2.9c1.1-1.6,3.4-1.9,4.9-0.8c0,0,0,0,0,0c1.6,1.2,1.9,3.4,0.8,5L7.9,37
                c-1.1,1.6-3.4,1.9-4.9,0.8c0,0,0,0,0,0C1.3,36.6,1,34.4,2.1,32.8z"
              />
            </g>
            <g>
              <path
                className="caret"
                fill={'currentColor'}
                d="M30.4,2.9l22.5,31.1c1.2,1.6,0.8,3.8-0.8,5c-1.6,1.2-3.8,0.8-4.9-0.8c0,0,0,0,0,0L24.6,7.1
                c-1.2-1.6-0.8-3.8,0.8-5C27,0.9,29.2,1.3,30.4,2.9C30.4,2.9,30.4,2.9,30.4,2.9z"
              />
            </g>
          </g>
        </g>
      </g>
    </>
  ),
});
